export enum ItemType {
  Service = 'SERVICE',
  FixedAsset = 'FIXED_ASSET',
  Inventory = 'INVENTORY',
  NonInventory = 'NON_INVENTORY',
  OtherCurrentAsset = "OTHER_CURRENT_ASSET",
  BillOfMaterials = 'BILL_OF_MATERIALS',
  Shipping = 'SHIPPING',
  Discount = 'DISCOUNT',
  OtherCharges = 'OTHER_CHARGES',
  SalesTax = 'SALES_TAX',
  Project = 'PROJECT'
}

export namespace ItemType {
  export function isMaterialItem(itemType: ItemType) {
    return itemType == ItemType.Inventory || itemType == ItemType.NonInventory || itemType == ItemType.BillOfMaterials;
  }

  export function isFixedAssetItem(itemType: ItemType) {
    return itemType == ItemType.FixedAsset;
  }

  export function isInventoryItem(itemType: ItemType) {
    return itemType == ItemType.Inventory;
  }

  export function isNonInventoryItem(itemType: ItemType) {
    return itemType == ItemType.NonInventory;
  }

  export function isBomItem(itemType: ItemType) {
    return itemType == ItemType.BillOfMaterials;
  }

  export function isOtherCurrentAsset(itemType: ItemType) {
    return itemType == ItemType.OtherCurrentAsset;
  }

  export function isInvOrBom(itemType: ItemType) {
    return ItemType.isInventoryItem(itemType) || ItemType.isBomItem(itemType);
  }

  export function isInvBomFixedOrOtherCurrentAsset(itemType: ItemType) {
    return ItemType.isInventoryItem(itemType) || ItemType.isBomItem(itemType) || ItemType.isOtherCurrentAsset(itemType)
      || ItemType.isFixedAssetItem(itemType);
  }

  export function isNonInvServiceOrOdc(itemType: ItemType) {
    return ItemType.isNonInventoryItem(itemType) || ItemType.isServiceItem(itemType) || ItemType.isOdcItem(itemType);
  }

  export function isServiceItem(itemType: ItemType) {
    return itemType == ItemType.Service;
  }

  export function isOdcItem(itemType: ItemType) {
    return itemType == ItemType.OtherCharges;
  }

  export function isSpecialItem(itemType: ItemType | any) {
    return itemType == ItemType.SalesTax || itemType == ItemType.Discount || itemType == ItemType.Shipping;
  }

  export function isProjectItem(itemType: ItemType) {
    return itemType == ItemType.Project;
  }
  export function isManufacturedItem(itemType: ItemType) {
    return isMaterialItem(itemType) || isFixedAssetItem(itemType);
  }
  export function isTaxableItem(itemType: ItemType) {
    return (ItemType.isManufacturedItem(itemType) || ItemType.isServiceItem(itemType) || ItemType.isProjectItem(itemType) );
  }
  export function isWareHouseItem(itemType: ItemType) {
    return itemType == ItemType.Inventory;
  }

}
